var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.605469,
    width: 62,
    height: 59.3768,
    rx: 10,
    fill: "#080808"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_55875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0274 40.1495H35.7805V37.2754C32.708 38.2219 29.4057 38.2162 26.4055 37.3316V40.1495H23.9649C22.9268 40.1495 22.4011 41.3228 23.1305 42.0139L30.1453 48.6571C30.603 49.0908 31.3521 49.0911 31.8118 48.6585L38.8594 42.0154C39.5916 41.3264 39.0674 40.1495 38.0274 40.1495Z",
    fill: "#00E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8203 13.9668C14.8219 14.7457 11 18.8156 11 23.703C11 28.5912 14.8219 32.6596 19.8195 33.4385C14.3377 27.9456 14.3412 19.457 19.8203 13.9668V13.9668Z",
    fill: "#00E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1797 13.9668C47.6516 19.4497 47.67 27.9378 42.1805 33.4385C47.1781 32.6596 51 28.5912 51 23.703C51 18.8156 47.1781 14.7457 42.1797 13.9668V13.9668Z",
    fill: "#00E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 11.6055C23.8614 11.6055 18.0537 17.0323 18.0537 23.7027C18.0537 30.3732 23.8614 35.8 31 35.8C38.1386 35.8 43.9462 30.3732 43.9462 23.7027C43.9462 17.0323 38.1386 11.6055 31 11.6055ZM30.0579 22.0589L32.9714 23.3901C33.9367 23.8311 34.5604 24.7649 34.5604 25.7689C34.5604 27.0728 33.5464 28.1587 32.2167 28.3763V29.187C32.2167 29.7917 31.692 30.282 31.0448 30.282C30.3976 30.282 29.8729 29.7917 29.8729 29.187V28.4168H28.619C27.9718 28.4168 27.4472 27.9265 27.4472 27.3218C27.4472 26.717 27.9718 26.2267 28.619 26.2267H31.7267C32.244 26.2267 32.4065 25.5697 31.942 25.3575L29.0284 24.0263C26.5961 22.915 27.0406 19.4159 29.7832 18.967V18.2295C29.7832 17.6247 30.3079 17.1345 30.955 17.1345C31.6022 17.1345 32.1269 17.6247 32.1269 18.2295V18.9267H33.3886C34.0358 18.9267 34.5605 19.4169 34.5605 20.0217C34.5605 20.6264 34.0358 21.1167 33.3886 21.1167H30.2732C29.7258 21.1167 29.6075 21.8531 30.0579 22.0589Z",
    fill: "#00E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_55875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 37.3768,
    fill: "white",
    transform: "translate(11 11.6055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon-5.e49c9b1a16312ba08f57fb510659a297.svg";
export { ForwardRef as ReactComponent };